module.exports = __webpack_public_path__ + "img/logo.a8b867cf.png";